import React from 'react';
import { Modal } from './Modal';
import { PrimaryButton } from './PrimaryButton';
import { GhostButton } from './GhostButton';
import { AlertTriangle } from 'lucide-react';

export const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", isDestructive = false }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="max-w-md">
            <div className="space-y-4">
                <div className="flex items-start gap-3">
                    {isDestructive && (
                        <div className="bg-red-900/20 p-2 rounded-full text-red-500">
                            <AlertTriangle size={24} />
                        </div>
                    )}
                    <div className="text-stone-300 text-sm leading-relaxed">
                        {message}
                    </div>
                </div>
                <div className="flex justify-end gap-2 pt-4 border-t border-stone-700">
                    <GhostButton onClick={onClose}>{cancelText}</GhostButton>
                    <button
                        onClick={onConfirm}
                        className={`px-4 py-2 rounded text-sm font-bold transition-colors ${isDestructive
                                ? 'bg-red-600 hover:bg-red-500 text-white'
                                : 'bg-blue-600 hover:bg-blue-500 text-white'
                            }`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </Modal>
    );
};
